import Ajax from '../../../../util/ajax';
export function zigbeeMove(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/move';
        const value = {
            'mode': payload.mode,
            'rate': payload.rate,
            'execute if off': payload.executeIfOff
        };
        ajax.post(url, value);
    };
}
